var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCpdata(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 11,
    height: 11,
    viewBox: "0 0 11 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_0_1)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.875 1H5.125C4.91406 1 4.75 1.1875 4.75 1.375V9.625C4.75 9.83594 4.91406 10 5.125 10H5.875C6.0625 10 6.25 9.83594 6.25 9.625V1.375C6.25 1.1875 6.0625 1 5.875 1ZM5.125 0.25H5.875C6.48438 0.25 7 0.765625 7 1.375V9.625C7 10.2578 6.48438 10.75 5.875 10.75H5.125C4.49219 10.75 4 10.2578 4 9.625V1.375C4 0.765625 4.49219 0.25 5.125 0.25ZM2.125 5.5H1.375C1.16406 5.5 1 5.6875 1 5.875V9.625C1 9.83594 1.16406 10 1.375 10H2.125C2.3125 10 2.5 9.83594 2.5 9.625V5.875C2.5 5.6875 2.3125 5.5 2.125 5.5ZM1.375 4.75H2.125C2.73438 4.75 3.25 5.26562 3.25 5.875V9.625C3.25 10.2578 2.73438 10.75 2.125 10.75H1.375C0.742188 10.75 0.25 10.2578 0.25 9.625V5.875C0.25 5.26562 0.742188 4.75 1.375 4.75ZM8.875 2.5C8.66406 2.5 8.5 2.6875 8.5 2.875V9.625C8.5 9.83594 8.66406 10 8.875 10H9.625C9.8125 10 10 9.83594 10 9.625V2.875C10 2.6875 9.8125 2.5 9.625 2.5H8.875ZM7.75 2.875C7.75 2.26562 8.24219 1.75 8.875 1.75H9.625C10.2344 1.75 10.75 2.26562 10.75 2.875V9.625C10.75 10.2578 10.2344 10.75 9.625 10.75H8.875C8.24219 10.75 7.75 10.2578 7.75 9.625V2.875Z",
    fill: "#2AAD8F"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_1"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 826,
    height: 634,
    fill: "white",
    transform: "translate(-65 -22)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCpdata);
export default __webpack_public_path__ + "static/media/cpdata.17dcae786cbe91659c4c85ff4529548d.svg";
export { ForwardRef as ReactComponent };